import { ServiceItem, CultureItem, ProjectCategory, ProcessStep, TeamMember } from './types';

export const COMPANY_NAME_CN = "湖南剑云税务师事务所有限公司";
export const COMPANY_NAME_EN = "Hunan Jianyun Certified Tax Agents Co.,Ltd";
export const ADDRESS = "湖南湘江新区雷锋街道枫林三路1599号骏达大厦综合楼";

export const CULTURE_ITEMS: CultureItem[] = [
  {
    title: "服务愿景",
    enTitle: "VISION",
    description: "成为企业信赖的战略级财税伙伴，助力企业穿越合规迷雾，捕捉政策红利。"
  },
  {
    title: "服务初心",
    enTitle: "MISSION",
    description: "合规为基、价值为核。致力于让企业财税管理从“被动合规”转向“主动增值”。"
  },
  {
    title: "发展理念",
    enTitle: "PHILOSOPHY",
    description: "技术赋能专业。引入大数据、人工智能实现账务处理自动化、风险排查智能化。"
  },
  {
    title: "核心优势",
    enTitle: "ADVANTAGE",
    description: "“1+N”服务模式：1个专属财税管家 + N个专家顾问团，解决问题不推诿，专家团队做后盾。"
  }
];

export const SERVICES_DATA: ServiceItem[] = [
  {
    title: "税务板块",
    description: "深耕涉税鉴证与服务，筑牢合规底线，通过税务筹划为企业创造实质性价值。",
    items: [
      "【基础保障类】企业财务/税务业务流程外包、代理记账、纳税申报",
      "【价值创造类】税务规划、高新认定、跨境税务服务、企业并购税务服务、退税、减免税服务",
      "【风险管控类】税务健康检查、税务稽查应对、合规性服务"
    ],
    iconName: "ShieldCheck",
    image: "https://images.unsplash.com/photo-1586281380349-632531db7ed4?auto=format&fit=crop&q=80&w=1200"
  },
  {
    title: "咨询板块",
    description: "聚焦企业风险控制与资本运作支持，赋能企业战略升级。提供涵盖并购全周期的财务与管理咨询。",
    items: [
      "【风险管理】公司治理复核、内控体系建设、内部审计、上市合规准备审查、合同履行审查、信息系统风险",
      "【并购财务顾问】收购/退出策略咨询、市场进入测算、并购目标搜寻、私募融资、交易谈判支持、管理层收购(MBO)",
      "【交易支持】财务尽调、IPO财务顾问、财务梳理及重整、会计制度设计、全面预算管理、集团财务系统设计与实施"
    ],
    iconName: "TrendingUp",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=1200"
  },
  {
    title: "创新与特色服务",
    description: "响应金税四期迭代，推出数字化财税管理与专项增值服务，助力企业降本增效。",
    items: [
      "财税数字化系统搭建（自动化/智能化）",
      "研发费用优化与专项规划",
      "投后财税管理特色服务",
      "股权架构设计与战略升级咨询"
    ],
    iconName: "Zap",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=1200"
  }
];

export const PROCESS_DATA: ProcessStep[] = [
  {
    id: 1,
    title: "精准诊断",
    description: "深度掌握各行业政策要点，进行精准风险排查与合规性评估。",
    iconName: "MessageSquare"
  },
  {
    id: 2,
    title: "定制方案",
    description: "为不同行业、不同阶段企业提供全周期、定制化财税解决方案。",
    iconName: "ClipboardCheck"
  },
  {
    id: 3,
    title: "1+N 模式",
    description: "专属管家+专家顾问团实时响应，确保方案高效落地实施。",
    iconName: "Users"
  },
  {
    id: 4,
    title: "技术赋能",
    description: "通过数字化服务平台，实现智能化政策匹配与自动化账务处理。",
    iconName: "Zap"
  },
  {
    id: 5,
    title: "全程陪伴",
    description: "随叫随到、随问随答，持续深耕专业能力，助力行稳致远。",
    iconName: "CheckCircle"
  }
];

export const EXPERIENCE_DATA: ProjectCategory[] = [
  {
    id: "listed-experience",
    title: "国企及上市公司服务经验",
    subtitle: "STATE-OWNED & LISTED COMPANIES",
    content: [
      {
        title: "代表性客户",
        list: [
          "湖南梦洁家纺股份有限公司 (股票代码002397)",
          "中核健康投资有限公司",
          "航天凯天环保科技股份有限公司",
          "湖南工商大学",
          "湖南财政经济学院",
          "雨敞坪镇人民政府"
        ]
      }
    ]
  },
  {
    id: "private-experience",
    title: "民营企业服务经验",
    subtitle: "PRIVATE ENTERPRISE EXPERIENCE",
    description: "累计服务企业涵盖农业、建工、电商、制造、软件等多个领域。",
    content: [
      {
        title: "核心合作企业",
        list: [
          "长沙湘润农业科技开发有限公司",
          "长沙永乐康仪器设备有限公司",
          "湖南亘恒建设工程有限公司",
          "湖南源安能源有限公司"
        ]
      }
    ]
  }
];

export const TEAM_DATA: TeamMember[] = [
  {
    name: "资深专家团",
    title: "CPA / CTA / CMA 领衔",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80",
    certifications: ["注册会计师 (CPA)", "税务师 (CTA)", "美国管理会计师 (CMA)"],
    specialties: ["平均从业经验超10年", "复合知识储备", "上市公司辅导经验"],
    experience: "核心团队10年+"
  }
];